import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Formik, Form, FieldArray } from "formik";
import FormikSelectField from "../../../shared/components/FormikSelectField";
import FormikCheckboxField from "../../../shared/components/FormikCheckboxField";
import FormikDatePickerField from "../../../shared/components/FormikDatePickerField";
import DefaultButton from "../../../shared/components/DefaultButton";
import Breadcrumbs from '../../../shared/components/Breadcrumbs';
import { Col, Row, Card, Button, Modal, Collapse } from "react-bootstrap";
import {  CANCEL, SAVE, START_DATE, END_DATE, NOTIFICATION, BACKTOLIST} from "../../../shared/constants/Constants";
import { loadJobTitlesDataRequest } from "../../jobtitles/redux/Actions";
import { loadMarketDataRequest } from "../../market/redux/Actions";
import { loadRegionDataRequest } from "../../region/redux/Actions";
import { loadEmployeeGetDataRequest,loadActiveEmployeeDataRequest} from "../../employees/redux/Actions";
import { loadNotificationDataRequest, loadNotificationGetDataRequest, loadNotificationFormAddDataRequest, loadNotificationUpdateDataRequest } from "../redux/Actions";
import ReactQuill, { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';
import 'react-quill/dist/quill.snow.css';
import '../../../App.css';
import { parse } from "date-fns";
import NotificationQuestions from "./NotificationQuestions";

Quill.register('modules/imageResize', ImageResize);
//Quill.register('modules/imageResize', ImageResize);
//const ack_types = ['Info', 'Warning', 'Alert'];
//const application = ['WV Mobile App', 'DOMO', 'WVGO', 'VSALES', 'WV CHAT', 'UltiPro'];
const application = [
  { value: "APP", label: "WV Mobile App" },
  // { value: "DOMO", label: "DOMO" },
  // { value: "WVGO", label: "WVGO" },
  // { value: "VSALES", label: "VSALES" },
  // { value: "WVCHAT", label: "WV CHAT" },
  // { value: "ULTIPRO", label: "UltiPro" },
];
const notificationLevels = [
  { value: 'company', label: 'Entire Company' },
  { value: 'jobTitle', label: 'Job Title Based' },
  { value: 'market', label: 'Market Based' },
  { value: 'region', label: 'Region Based' },
  { value: 'department', label: 'Department Based' },
  { value: 'employee', label: 'Employee Based' },
];


const NotificationForm = ({ isNewNotification, onSubmit, cancel }) => {

  const dispatch = useDispatch();
  const { id } = useParams(); 
  const navigate = useNavigate();
  const { jobtitles } = useSelector(store => store.jobtitle);
  const { markets } = useSelector(store => store.market);
  const { regions } = useSelector(store => store.region);
  const { active_employees } = useSelector(store => store.employee);   
  const [contentType, setContentType] = useState('text');
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const { notify } = useSelector(state => state.notification);
  const [collapse, setCollapse] = useState({ section1: true });

  //Edit Form 
  const notificationData = Array.isArray(notify) ? notify[0] : notify;
  const [notificationLevel, setNotificationLevel] = useState(id ? notificationData?.notification_level || '' : '');
  // pull ids from mappings if present
    const regionIds = notificationData?.mappings
      ?.filter(m => m.region_id)
      .map(m => m.region_id) || [];

    const marketIds = notificationData?.mappings
      ?.filter(m => m.market_id)
      .map(m => m.market_id) || [];

    const jobTitleIds = notificationData?.mappings
      ?.filter(m => m.job_title_id)
      .map(m => m.job_title_id) || [];

    const employeeIds = notificationData?.mappings
      ?.filter(m => m.employee_id)
      .map(m => m.employee_id) || [];

    // Check if the question editable   
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      // Parse start_date if exists
      const startDate = notificationData?.start_date
        ? parse(notificationData.start_date, "dd-MM-yyyy", new Date())
        : null;
      if (startDate) startDate.setHours(0, 0, 0, 0);

      // Parse end_date if exists
      const endDate = notificationData?.end_date
        ? parse(notificationData.end_date, "dd-MM-yyyy", new Date())
        : null;
      if (endDate) endDate.setHours(0, 0, 0, 0);

      // ✅ only allow add/remove if new notification OR start_date >= tomorrow
      const allowAddRemove = !id || (startDate && startDate >= tomorrow);

      // ✅ only allow editing if new notification OR end_date >= tomorrow
      const isQuestionsEditable = !id || (endDate && endDate >= tomorrow);


    const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }], // <-- color and background color
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [ 'image'],
      ['clean']
    ] ,
    imageResize: {
      modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
    }
  };

  useEffect(() => {
    if (id) dispatch(loadNotificationGetDataRequest(id));    
    if (!jobtitles || jobtitles.length === 0) dispatch(loadJobTitlesDataRequest());
    if (!markets || markets.length === 0) dispatch(loadMarketDataRequest());
    if (!regions || regions.length === 0) dispatch(loadRegionDataRequest());
    if(!active_employees || active_employees.length === 0) dispatch(loadActiveEmployeeDataRequest());
  }, [dispatch]);
 
  const validate = (values) => {
    const errors = {};
    if (!values.ack_header) errors.ack_header = "Required";
    if (!values.bypass_max) errors.bypass_max = "Required";
    if (!values.ack_content) errors.ack_content = "Required";
    if (values.document_link) {
        try {
          new URL(values.document_link); // throws if invalid
        } catch {
          errors.document_link = "Please enter a valid URL";
        }
    }
   // if (!values.ack_type) errors.ack_type = "Required";
    if (!values.application || values.application.length === 0) errors.application = "Required";
    if (!values.start_date) errors.start_date = "Required";
    if (!values.end_date) errors.end_date = "Required";
    if (values.start_date && values.end_date && new Date(values.start_date) > new Date(values.end_date)) {
      errors.end_date = "End date must be after start date";
    }
    // Conditional validation for questions
    if (values.questions && values.questions.length > 0) {
          const questionErrors = {};
          values.questions.forEach((q, index) => {
            const qErrors = {};
            const hasAnyValue = (q.question?.trim() || q.q_type?.trim() || q.q_options?.trim())?.length > 0;
            if (hasAnyValue) {
              if (!q.question?.trim()) qErrors.question = "Required";
              if (!q.q_type?.trim()) qErrors.q_type = "Required";
              if (q.q_type === "options" && !q.q_options?.trim()) {
                qErrors.q_options = "Required";
              }
            }
            if (Object.keys(qErrors).length > 0) {
              questionErrors[index] = qErrors;
            }
          });
          if (Object.keys(questionErrors).length > 0) {
            errors.questions = questionErrors;
          }
        }
      // Level-specific validation
    if (notificationLevel === 'jobTitle' && !values.job_title_id) errors.job_title_id = "Required" ;
    if (notificationLevel === 'market' && (!values.market_id || values.market_id.length === 0)) errors.market_id = "Required";
    if (notificationLevel === 'region' && (!values.region_id || values.region_id.length === 0)) errors.region_id = "Required";
    if (notificationLevel === 'department' && !values.department) errors.department = "Required";
    if (notificationLevel === 'employee' && (!values.employee_id || values.employee_id.length === 0)) errors.employee_id = "Required";

    return errors;
  };

  useEffect(() => {
          if (notificationData?.notification_level) {
            setNotificationLevel(notificationData.notification_level);
          }
  }, [notificationData]);    


  const initialValues = id
  ? {
      ack_header: notificationData?.ack_header || '',
      ack_content: notificationData?.ack_content || '',
      document_link: notificationData?.document_link || '',
      //ack_type: notificationData?.ack_type || '',
      application: notificationData?.application? Array.isArray(notificationData.application)? notificationData.application : [notificationData.application] : [],
      job_title_id: jobTitleIds,
      employee_id: employeeIds,
      department: notificationData?.department || '',
      saps: notificationData?.saps || [],
      market_id: marketIds,
      region_id: regionIds,
      start_date: notificationData?.start_date ? parse(notificationData.start_date, "dd-MM-yyyy", new Date()) : null,
      end_date: notificationData?.end_date ? parse(notificationData.end_date, "dd-MM-yyyy", new Date()) : null,
      bypass_max: notificationData?.bypass_max || '',
      status: notificationData?.status ?? false,
      questions: notificationData?.questions || [{ id: "", q_ref: "q1", question: "",q_type: "",q_options: "", q_required: false, }],
    }
  : {
      ack_header: '',
      ack_content: '',
      document_link: '',
      //ack_type: '',
      application: ["APP"],
      job_title_id: '',
      employee_id: [],
      department: '',
      saps: [],
      market_id: [],
      region_id: [],
      start_date: '',
      end_date: '',
      bypass_max: '',
      status: true,
      questions: [{ q_ref: "q1", question: "", q_type: "", q_options: "", q_required: false, },],
     };


    //   const messageTypeIcons = {
    //   Info: "ℹ️",      // Or use an image: <img src="info.png" ... />
    //   Warning: "⚠️",
    //   Alert: "🚨"
    // };

  const handleSubmit = (values) => {
    const cleanedQuestions = values.questions.filter(q => q.question?.trim() !== "" || q.q_type?.trim() !== "" || q.q_options?.trim() !== "").map((q, index) => ({...(q.id ? { id: q.id } : {}),
                              q_ref: `q${index + 1}`,question: q.question.trim(),q_type: q.q_type, q_options: q.q_type === "options" ? q.q_options : null, q_required: q.q_required,
                            }));
    const request = {
      ack_header: values.ack_header,
      bypass_max: values.bypass_max,
      ack_content: values.ack_content,
      document_link: values.document_link,
      contentType, // from state
      ack_type: "Info",
      application: Array.isArray(values.application) ? values.application[0] : values.application,
      notificationLevel, // from state
      job_title_id: values.job_title_id,
      department: values.department,
      market_id: values.market_id,
      region_id: values.region_id,
      employee_id: values.employee_id, 
      start_date: values.start_date ? new Date(values.start_date).toISOString() : null,
      end_date: values.end_date ? new Date(values.end_date).toISOString() : null,
      status: values.status,
      questions: cleanedQuestions,
    }; 
    if (id) {
      // EDIT Noti
     dispatch(loadNotificationUpdateDataRequest({id,...request}));
    } else {
      // CREATE Noti
      dispatch(loadNotificationFormAddDataRequest(request));  
    }
    navigate("/notification"); // navigate after save
    console.log("Payload", id ? { id, ...request } : request);
  };

  return (
    <>
      <Row>
        <Col>
          <Breadcrumbs children={[ {href:'/notification/', label: NOTIFICATION },
            { label: 'Notification Configuration' }]} />
        </Col>
        <Col className="d-flex justify-content-end mb-3">
                  <DefaultButton
                    buttonClass="default-btn-color"
                    buttonTitle={BACKTOLIST}
                    actionBlock={() => {
                      navigate("/notification");
                    }}
                  />
                </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              {/* Notification Level Selection */}
              <div className="mb-3">
                <label className="form-label">Notification Level <span className="error-text">*</span></label>
                <select
                  className="form-select"
                  value={notificationLevel}
                  onChange={e => setNotificationLevel(e.target.value)}
                  required
                >
                  <option value="">Select Level</option>
                  {notificationLevels.map(lvl => (
                    <option key={lvl.value} value={lvl.value}>{lvl.label}</option>
                  ))}
                </select>
              </div>
              {/* Only show the form if a level is selected */}
              {notificationLevel && (                
                <Formik
                  enableReinitialize 
                  initialValues={initialValues}
                  validate={validate}
                  onSubmit={handleSubmit}
                >
                  {({ values,errors, setFieldValue, setFieldTouched, resetForm }) => (
                    <>
                      <Form className="row g-4">
                        <div className="col-md-6">
                          <label className="form-label">Notification Header <span className="error-text">*</span></label>
                          <Field name="ack_header" className="form-control" type="text" />
                          <span className="error-text"><ErrorMessage name="ack_header" /></span>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">By Pass Count <span className="error-text">*</span></label>
                          <Field name="bypass_max" className="form-control" type="number" min= "0" />
                          <span className="error-text"><ErrorMessage name="bypass_max" /></span>
                        </div>
                        {/* <div className="col-md-6">
                          <label className="form-label">Content Type</label>
                          <select
                            className="form-select"
                            value={contentType}
                            onChange={e => setContentType(e.target.value)}
                            onHide ={true}
                          >
                            <option value="text">Text</option>
                            <option value="image">Image Link</option>
                            <option value="video">Video Link</option>
                          </select>
                        </div> */}
                     
                        <div className="col-md-12">
                          <label className="form-label">Notification Content <span className="error-text">*</span></label>
                          {contentType === "text" && (
                            <>
                            <div  className="editor-container">
                              
                              <ReactQuill
                                theme="snow"
                                value={values.ack_content}
                                onChange={val => setFieldValue("ack_content", val)}
                                style={{ background: "#fff", marginBottom: "24px" }}
                                modules={quillModules}
                              />
                              </div>
                              <span className="error-text"><ErrorMessage name="ack_content" /></span>
                            </>
                          )}
                          {contentType === "image" && (
                            <>
                              <Field name="ack_content" className="form-control" type="url" placeholder="Paste image URL here" />
                              <span className="error-text"><ErrorMessage name="ack_content" /></span>
                            </>
                          )}
                          {contentType === "video" && (
                            <>
                              <Field name="ack_content" className="form-control" type="url" placeholder="Paste video URL here" />
                              <span className="error-text"><ErrorMessage name="ack_content" /></span>
                            </>
                          )}
                        </div>
                          <div className="col-md-6">
                            <label className="form-label">Document Link</label>
                            <Field
                              name="document_link"
                              className="form-control"
                              type="url"
                              placeholder="Please Place the Links here"
                            />
                            <span className="error-text">
                              <ErrorMessage name="document_link" />
                            </span>
                          </div>

                        {/* <FormikSelectField
                          name="ack_type"
                          label="Message Type"
                          value={values.ack_type}
                          onChange={setFieldValue}
                          placeholder="Message Type"
                          required
                        >
                          <option value="">Select Type</option>
                          {ack_types.map(type => (
                            <option key={type} value={type}>{type}</option>
                          ))}
                        </FormikSelectField> */}
                        <FormikSelectField
                          name="application"
                          label="Applications"
                          value={values.application}
                          onChange={setFieldValue}
                          placeholder="Applications"
                          isMulti
                          required
                        >
                          {application.map(app => ( <option key={app.value} value={app.value}>{app.label}</option>))}
                        </FormikSelectField>                          
                        {notificationLevel === 'jobTitle' && (
                          <FormikSelectField
                            name="job_title_id"
                            label="Job Title"
                            value={values.job_title_id}
                            onChange={setFieldValue}
                            placeholder="Job Title"
                            isMulti
                            required
                          >
                            {/* <option value="">Select Job Title</option> */}
                            {jobtitles.filter(jt => jt.is_active === true).map(jt => (
                              <option key={jt.id} value={jt.id}>{jt.job_title}</option>
                            ))}
                          </FormikSelectField>
                        )}
                        {notificationLevel === 'market' && (
                          <FormikSelectField
                            name="market_id"
                            label="Markets"
                            value={values.market_id}
                            onChange={setFieldValue}
                            placeholder="Markets"
                            isMulti
                            required
                          >
                            {markets.filter(market_id => market_id.active === 0).map(market_id => (
                              <option key={market_id.id} value={market_id.id}>{market_id.market_name}</option>
                            ))}
                          </FormikSelectField>
                        )}
                        {notificationLevel === 'region' && (
                          <FormikSelectField
                            name="region_id"
                            label="Regions"
                            value={values.region_id}
                            onChange={setFieldValue}
                            placeholder="Regions"
                            isMulti
                            required
                          >
                            {regions.filter(region => region.active === 0).map(region_id => (
                              <option key={region_id.id} value={region_id.id}>{region_id.region_name}</option>
                            ))}
                          </FormikSelectField>
                        )}
                        {notificationLevel === 'department' && (
                          <div className="col-md-6">
                            <label className="form-label">Department <span className="error-text">*</span></label>
                            <Field name="department" className="form-control" type="text" />
                            <span className="error-text"><ErrorMessage name="department" /></span>
                          </div>
                        )}
                        {notificationLevel === 'employee' && (
                          <FormikSelectField
                            name="employee_id"
                            label="Employees"
                            value={values.employee_id}
                            onChange={setFieldValue}
                            placeholder="Employees"
                            isMulti
                            required
                          >
                            {active_employees.map(employee_id => (
                                <option key={employee_id.employee_id} value={employee_id.employee_id}>
                                  {`${employee_id.first_name} ${employee_id.last_name} (${employee_id.employee_id})`}
                                </option>
                              ))}
                          </FormikSelectField>
                        )}
                        <div className="col-md-6 datepicker">
                          <label htmlFor={'start_date'} className="form-label">
                            {START_DATE} <span className="error-text">*</span>
                          </label>
                          <FormikDatePickerField
                            name="start_date"
                            value={values.start_date}
                            onChange={setFieldValue}
                            handleBlur={setFieldTouched}
                            placeholder={START_DATE}
                          />
                          <span className="error-text">
                            <ErrorMessage name={'startDate'} />
                          </span>
                        </div>
                        <div className="col-md-6 datepicker">
                          <label htmlFor={'end_date'} className="form-label">
                            {END_DATE} <span className="error-text">*</span>
                          </label>
                          <FormikDatePickerField
                            name="end_date"
                            value={values.end_date}
                            onChange={setFieldValue}
                            handleBlur={setFieldTouched}
                            placeholder={END_DATE}
                            minDate={values.start_date ? new Date(values.start_date) : new Date()} 

                          />
                          <span className="error-text">
                            <ErrorMessage name={'end_date'} />
                          </span>
                        </div>
                        <div className="col-md-6 d-flex align-items-center">
                            <FormikCheckboxField  
                              name="status"
                              label="Active"
                              value={values.status}
                              setFieldValue={setFieldValue}
                              onChange={(value) => {
                                setFieldValue("status", value);
                              }}
                            />
                            <span className="error-text"><ErrorMessage name="status" /></span>
                        </div>
                        <div className="col-md-12">
                            <NotificationQuestions 
                                values={values} 
                                setFieldValue={setFieldValue} 
                                setFieldTouched={setFieldTouched} 
                                collapse={collapse} 
                                setCollapse={setCollapse}
                                isQuestionsEditable={isQuestionsEditable}
                                allowAddRemove={allowAddRemove}

                              />
                          </div>
                                                                      
                        <Col md={12}>
                          <DefaultButton
                            buttonClass={"btn btn-secondary me-2"}
                            buttonTitle={CANCEL}
                            actionBlock={() => resetForm()}
                          />
                          <DefaultButton
                            buttonClass={"btn btn-secondary default-btn-color"}
                            buttonTitle={SAVE}
                            buttonType={"submit"}
                          />
                          <Button
                            variant="info"
                            className="btn btn-secondary ms-2 btn-preview-orange"
                            type="button"
                            onClick={() => {
                              setPreviewData({
                                header: values.ack_header,
                                content: values.ack_content,
                                document_link: values.document_link,
                                contentType,
                               // ack_type: values.ack_type,
                                application: values.application,
                              });
                              setPreviewOpen(true);
                            }}
                          >
                            Preview
                          </Button>
                      </Col>
                    </Form>

                    {/* Preview Modal */}
                      <Modal show={previewOpen} onHide={() => setPreviewOpen(false)} size="lg" >
                        <Modal.Header closeButton style={{ backgroundColor: "#f5f5f5" }}>
                          <Modal.Title>Notification Preview</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: "#f5f5f5" }}>
                            <h5 className="notification-heading">
                          {/* {previewData.ack_type && (
                            <span style={{ marginRight: 8 }}>
                            {messageTypeIcons[previewData.ack_type] || ""}
                            </span>
                          )}   */}
                          {previewData.header}</h5>

                          <hr style={{ margin: "8px 0", border: "0", height: "6px", backgroundColor: "#999" }} />

                          {previewData.contentType === "text" && (
                            <div className="notification-preview" dangerouslySetInnerHTML={{ __html: previewData.content }} />
                          )}
                          {previewData.contentType === "image" && previewData.content && (
                            <img className="notification-preview img" src={previewData.content} alt="Notification" style={{ maxWidth: "100%" }} />
                          )}
                          {previewData.contentType === "video" && previewData.content && (
                            <video controls style={{ maxWidth: "100%" }}>
                              <source src={previewData.content} />
                              Your browser does not support the video tag.
                            </video>
                          )}
                          {previewData.document_link && (
                              <div style={{ marginTop: "12px", marginLeft: "20px"}} className="notification-link">
                                <a
                                  href={previewData.document_link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ color: "#007bff", fontWeight: 500,fontStyle: "italic",   // italic
                                    textDecoration: "underline"
                                  }}
                                >
                                  Click Here
                                </a>
                              </div>
                            )}

                          {/* <div className="mt-3">
                            <strong>Message Type:</strong> {previewData.messageType}
                          </div>
                          <div>
                            <strong>Applications:</strong> {Array.isArray(previewData.applications) ? previewData.applications.join(", ") : ""}
                          </div> */}
                        </Modal.Body>
                        <Modal.Footer style={{ backgroundColor: "#f5f5f5" }}>
                          <Button variant="secondary" onClick={() => setPreviewOpen(false)}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  )}
                </Formik>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default NotificationForm;